'use strict';

let requireOrNull;
if (process.env.WEBPACK) {
  requireOrNull = require;
} else {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'Juice',
    module: requireOrNull(
      '../../../../modules/juice_program/frontend/juice_program'
    ),
    featureCheck: serverObj =>
      serverObj.buyButton && serverObj.buyButton.isJuiceProgramEnabled,
  },
  {
    name: 'CashBack',
    module: requireOrNull(
      '../../../../modules/cash_back/desktop_2016/frontend/cash_back'
    ),
    featureCheck: serverObj => serverObj.cashBack,
  },
];

const nonCritModules = [
  {
    name: 'AsyncScripts',
    module: requireOrNull('../async_scripts/local'),
  },
  {
    name: 'Merchant',
    module: requireOrNull('../../../../modules/merchant/frontend/lazy_load'),
    featureCheck: serverObj =>
      !serverObj.merchantV2 &&
      serverObj.merchant &&
      serverObj.merchant.clientSideMerchantLocations &&
      serverObj.loadSwitch &&
      serverObj.loadSwitch.shouldLoadLazyLoadMerchantLocations,
  },
  {
    name: 'Value Proposition',
    module: requireOrNull('../../../../modules/value_proposition/frontend'),
    featureCheck: serverObj => serverObj.valueProposition,
  },
];

module.exports = { critModules, nonCritModules };
